<app-image-section-head [title]="title" [description]="description" [image]="image"></app-image-section-head>

<main id="main-content" class="container">
    <div class="row">
        <div class="col-12 mb-3">
            <h2 [innerHTML]="wpData?.acf.titulo_inicial"></h2>
            <p [innerHTML]="wpData?.acf.descripcion_inicial"></p>
        </div>
        <div class="col-12 con-map p-0 mb-3">
            <div style="height: 75vh; width: 90%; margin: auto;"><iframe title="Mapa interactivo de las Zonas de Bajas Emisiones en Cataluña" width="100%" height="100%" frameborder="0" scrolling="no" marginheight="0" marginwidth="0" src="https://www.instamaps.cat/visor.html?businessid=4e0041e7c63124cfb8fe5f1972d6f35d&3D=false&embed=1" ></iframe></div>
        </div>
        <div class="col-12 mb-3 descriptions card mb-3">
            <div *ngIf="wpData" [outerHTML]="wpData.content.rendered"></div>
        </div>
    </div>
</main>